import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { CardComponent } from './card/card.component';
import { PaginationComponent } from './pagination/pagination.component';
import { RouterModule } from '@angular/router';
import { PipeModule } from '../pipes/pipe.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from './modal/modal.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FilterFormComponent } from './filter-form/filter-form.component';
import { RangeSelectionComponent } from './range-selection/range-selection.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { ResultDivComponent } from './result-div/result-div.component';
import { FilterGeneralFormComponent } from './filter-general-form/filter-general-form.component';
import { MultipleSelectComponent } from './multiple-select/multiple-select.component';
import { ReportModalComponent } from './report-modal/report-modal.component';
import { DetailsTableComponent } from './details-table/details-table.component';
import { ResultReportTableComponent } from './result-report-table/result-report-table.component';
import { MaterialModule } from '../material/material.module';
import { SendEmailDialogComponent } from './send-email-dialog/send-email-dialog.component';
import { ImpactRowComponent } from './impact-row/impact-row.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { QuillModule } from 'ngx-quill';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TenantDialogComponent } from './navbar/tenant-dialog/tenat-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PipeModule,
    FormsModule,
    ScrollingModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    MaterialModule,
    LazyLoadImageModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    QuillModule.forRoot(),
  ],
  declarations: [
    NavbarComponent,
    FooterComponent,
    CardComponent,
    PaginationComponent,
    ModalComponent,
    FilterFormComponent,
    RangeSelectionComponent,
    RecoverPasswordComponent,
    ResultDivComponent,
    FilterGeneralFormComponent,
    MultipleSelectComponent,
    ReportModalComponent,
    DetailsTableComponent,
    ResultReportTableComponent,
    SendEmailDialogComponent,
    ImpactRowComponent,
    TenantDialogComponent
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    CardComponent,
    PaginationComponent,
    ModalComponent,
    FilterFormComponent,
    RecoverPasswordComponent,
    FilterGeneralFormComponent,
    MaterialModule
  ]
})
export class SharedModule { }
